import React, { useState, useEffect } from "react";
import axios from "axios";
import AWS from "aws-sdk";
import {  useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import MultiSelect from "multiselect-react-dropdown";
import { toast } from "react-toastify";
import { useLoader } from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const EditProductForm = () => {
  const { productId } = useParams(); 
const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    briefDescription: "",
    description: "",
    featuredProduct: false, 

    images: [],
    brands: "",
    slug: "",
    attributes: {},
    category: [""],
    price: {
      min: "",
      max: "",
    },
    marketplaces: [
      { marketplaceId: "", price: "", url: "" },
    ],
  });
console.log(formData,"formDataformData");

  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [marketplaces, setMarketplaces] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [brandsResponse, marketplacesResponse, categoriesResponse] = await Promise.all([
          axios.get(`${API_URL}/company/getAllCompany`),
          axios.get(`${API_URL}/marketplace/getAllMarketplaces`),
          axios.get(`https://api.solarstation.in/productcategory/getAllproductcategories`),
        ]);

        setBrands(brandsResponse.data.data);
        setMarketplaces(marketplacesResponse.data);
        setCategories(categoriesResponse.data.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchDropdownData();
  }, []);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await axios.get(`https://api.solarstation.in/products/getProduct/${productId}`);
        const product = response.data.data.product;
        setFormData(product); 
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    fetchProductData();
  }, [productId]);

  useEffect(() => {
    if (formData.category) {
      const fetchAttributes = async () => {
        setLoading(true);
        try {
          const response = await axios.get("https://api.solarstation.in/Attribute/getAllAttribute");
          setAttributes(response.data.data);
        } catch (error) {
          console.error("Error fetching attributes:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchAttributes();
    }
  }, [formData.category]);

  const handleMultiSelectChange = (selectedList) => {
    const selectedMarketplaces = selectedList.map((item) => ({
      marketplaceId: item._id,
      name: item.name,
      price: "",
      url: "",
    }));

    setFormData((prev) => ({
      ...prev,
      marketplaces: selectedMarketplaces,
    }));
  };

  const handleInputChange = (e, index, field) => {
    const updatedMarketplaces = [...formData.marketplaces];
    updatedMarketplaces[index][field] = e.target.value;
    setFormData({ ...formData, marketplaces: updatedMarketplaces });
  };

  const handleChange = (e, field, index = null) => {
    const { name, value } = e.target;

    if (field === "images") {
      const updatedImages = [...formData.images];
      updatedImages[index] = value;
      setFormData({ ...formData, images: updatedImages });
    } else if (field === "attributes") {
      setFormData({
        ...formData,
        attributes: { ...formData.attributes, [name]: value },
      });
    } else if (field === "price") {
      setFormData({
        ...formData,
        price: { ...formData.price, [name]: value },
      });
    } else if (field === "marketplaces") {
      const updatedMarketplaces = [...formData.marketplaces];
      updatedMarketplaces[index] = { ...updatedMarketplaces[index], [name]: value };
      setFormData({ ...formData, marketplaces: updatedMarketplaces });
    } else if (field === "category") {
      const updatedCategories = [...formData.category];
      updatedCategories[index] = value;
      setFormData({ ...formData, category: updatedCategories });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setFormData({ ...formData, category: selectedCategory, attributes: {} });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await axios.put(`https://api.solarstation.in/products/updateProduct/${productId}`, formData);
      alert("Product updated successfully!");
      navigate("/products"); 
    } catch (error) {
      console.error("Error updating product:", error);
      alert("Failed to update product. Please check the form data.");
    }
  };
const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};


  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const uploadedImages = [];
      for (const file of files) {
        const imageUrl = await handleImageUpload(file);
        if (imageUrl) {
          uploadedImages.push(imageUrl);
        }
      }
      setFormData((prev) => ({
        ...prev,
        images: [...prev.images, ...uploadedImages],
      }));
      e.target.value = "";
    }
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...formData.images];
    updatedImages.splice(index, 1);
    setFormData({ ...formData, images: updatedImages });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 p-4 max-w-lg mx-auto">
    <h2 className="text-2xl font-bold">Edit Product</h2>
  
    <div className="space-y-2">
      <label htmlFor="title" className="font-semibold">Title</label>
      <input
        type="text"
        id="title"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />
    </div>
  
    <div className="space-y-2">
      <label htmlFor="briefDescription" className="font-semibold">Brief Description</label>
      <input
        type="text"
        id="briefDescription"
        name="briefDescription"
        placeholder="Brief Description"
        value={formData.briefDescription}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />
    </div>
  
    <div className="space-y-2">
      <label htmlFor="description" className="font-semibold">Description</label>
      <textarea
        id="description"
        name="description"
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        className="w-full border p-2 rounded"
        required
      />
    </div>
    <div className="space-y-2">
  <label>Is Featured</label>
  <input
    type="checkbox"
    name="featuredProduct"
    checked={formData.featuredProduct}
    onChange={(e) =>
      setFormData({ ...formData, featuredProduct: e.target.checked })
    }
    className="w-full border p-2 rounded"
  />
</div>

  
    <div className="space-y-2">
      <label htmlFor="min" className="font-semibold">Min Price</label>
      <input
        type="number"
        id="min"
        name="min"
        value={formData.price.min}
        onChange={(e) => handleChange(e, "price")}
        placeholder="Min Price"
        className="w-full border p-2 rounded"
      />
    </div>
  
    <div className="space-y-2">
      <label htmlFor="max" className="font-semibold">Max Price</label>
      <input
        type="number"
        id="max"
        name="max"
        value={formData.price.max}
        onChange={(e) => handleChange(e, "price")}
        placeholder="Max Price"
        className="w-full border p-2 rounded"
      />
    </div>
  
    <div className="space-y-2">
      <label htmlFor="slug" className="font-semibold">Slug</label>
      <input
        type="text"
        id="slug"
        name="slug"
        value={formData.slug}
        onChange={handleChange}
        placeholder="Slug"
        className="w-full border p-2 rounded"
      />
    </div>
  
    <div className="space-y-2">
      <label htmlFor="images" className="font-semibold">Upload Images</label>
      <input
        type="file"
        id="images"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        className="w-full border p-2 rounded"
      />
      <p className="text-sm text-gray-500">You can select multiple images.</p>
    </div>
  
    <div className="space-y-2">
      {formData.images.length > 0 ? (
        formData.images.map((image, index) => (
          <div key={index} className="flex items-center space-x-4">
            <img
              src={image}
              alt={`Uploaded Image ${index + 1}`}
              className="w-20 h-20 object-cover"
            />
            <button
              type="button"
              onClick={() => handleRemoveImage(index)}
              className="bg-red-600 text-white py-1 px-3 rounded"
            >
              Remove
            </button>
          </div>
        ))
      ) : (
        <p>No images uploaded yet.</p>
      )}
    </div>
  
    <div className="space-y-2">
      <label htmlFor="brands" className="font-semibold">Select Brand</label>
      <select
        id="brands"
        name="brands"
        value={formData.brands}
        onChange={(e) => handleChange(e, "brands")}
        className="w-full border p-2 rounded"
        required
      >
        <option value="">Select Brand</option>
        {brands.map((brand) => (
          <option key={brand._id} value={brand._id}>
            {brand.title}
          </option>
        ))}
      </select>
    </div>
  
    <h3 className="font-semibold">Select Marketplaces</h3>
    <MultiSelect
      options={marketplaces}
      selectedValues={formData.marketplaces}
      onSelect={handleMultiSelectChange}
      onRemove={handleMultiSelectChange}
      displayValue="name"
    />
  
    <div className="space-y-4">
      {formData.marketplaces.map((marketplace, index) => (
        <div key={index}>
          <h4 className="font-semibold">Marketplace {index + 1}</h4>
          <div className="space-y-2">
            <label htmlFor={`url-${index}`} className="font-semibold">Marketplace URL</label>
            <input
              type="text"
              id={`url-${index}`}
              name="url"
              value={marketplace.url}
              onChange={(e) => handleInputChange(e, index, "url")}
              placeholder="Marketplace URL"
              className="w-full border p-2 rounded"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor={`price-${index}`} className="font-semibold">Price</label>
            <input
              type="number"
              id={`price-${index}`}
              name="price"
              value={marketplace.price}
              onChange={(e) => handleInputChange(e, index, "price")}
              placeholder="Price"
              className="w-full border p-2 rounded"
            />
          </div>
        </div>
      ))}
    </div>
  
    <div className="space-y-2">
      <label htmlFor="category" className="font-semibold">Select Category</label>
      <select
        id="category"
        name="category"
        value={formData.category}
        onChange={handleCategoryChange}
        className="w-full border p-2 rounded"
        required
      >
        <option value="">Select Category</option>
        {categories.map((category) => (
          <option key={category._id} value={category._id}>
            {category.name}
          </option>
        ))}
      </select>
    </div>
  
    {loading && <p>Loading attributes...</p>}
    {!loading && attributes.length > 0 && formData.category && (
      <div>
        <h3 className="text-lg font-semibold mt-6">Attributes</h3>
        {attributes.map((attribute) => (
          <div key={attribute._id} className="space-y-2">
            <label htmlFor={attribute.name} className="font-semibold">{attribute.name}</label>
            <input
              type="text"
              name={attribute.name}
              id={attribute.name}
              value={formData.attributes[attribute.name] || ""}
              onChange={(e) => handleChange(e, "attributes")}
              placeholder={`Enter ${attribute.name}`}
              className="w-full border p-2 rounded"
            />
          </div>
        ))}
      </div>
    )}
  
    <button type="submit" className="bg-blue-500 text-white py-2 px-6 rounded">
      Update Product
    </button>
  </form>
  
  );
};

export default EditProductForm;
